export type DrawerSize = 'small' | 'medium' | 'large' | 'full';
export type DrawerPosition = 'left' | 'right';

export interface DrawerConfig {
  size?: DrawerSize;
  position?: DrawerPosition;
  hasBackdrop?: boolean;
  closeOnBackdropClick?: boolean;
  closeOnEscape?: boolean;
}

export interface DrawerRef {
  open(): void;
  close(): void;
  toggle(): void;
  isOpen(): boolean;
}

export const DRAWER_SIZE_CLASSES: Record<DrawerSize, string> = {
  small: 'sm:w-80',
  medium: 'sm:w-96',
  large: 'sm:w-[32rem]',
  full: 'sm:w-full',
};

export const DRAWER_POSITION_CLASSES: Record<DrawerPosition, string> = {
  left: 'left-0',
  right: 'right-0',
};
